export class MeiliSearchError extends Error {
    name = "MeiliSearchError";
    constructor(...params) {
        super(...params);
    }
}
